import React from 'react';
import Seo from '../common/Seo';

import CallToAction from "../common/CallToAction";
import Drawer from "../common/Drawer";
import Projects from "../home/Projects";
import PageTitle from "./include/PageTitle";

import { ReactComponent as BackEndIcon } from "../assets/skills/backend.svg";
import OtherSkills from "./include/OtherSkills";
import SkillProjects from "./include/Projects";
import Process from "./include/Process";
import Stack from "./include/Stack";

import { routeIds } from "../i18n/routes";
import { useI18n } from "../i18n/I18nContext";
import ProjectQuery from "../model/Projects";

import NodeJS from "../assets/skills/NodeJS.png";
import MongoDB from "../assets/skills/MongoDB.png";
import MySQL from "../assets/skills/MySQL.png";
import Firebase from "../assets/skills/Firebase.png";
import JWT from "../assets/skills/JWT.png";
import Docker from "../assets/skills/Docker.png";


function BackEnd({route}) {
  const { pathFor, t } = useI18n();
  const steps = t("expertise.backend.steps");
  const projects = ProjectQuery({filter: "back-end"});
  const techs = [
    { name: "Node.js", logo: NodeJS },
    { name: "Firebase", logo: Firebase },
    { name: "MongoDB", logo: MongoDB },
    { name: "MySQL", logo: MySQL },
    { name: "JWT", logo: JWT },
    { name: "Docker", logo: Docker }
  ];

  const title = t("expertise.backend.title");
  const description = t("expertise.backend.description");

  return [
    <Seo title={title} description={description} />,
    <PageTitle id="back-end" title={t("expertise.backend.heading")} text={t("expertise.backend.intro")} logo={<BackEndIcon />} />,
    <div className="hidden bg-green"></div>,
    <Process steps={steps} color="green" />,
    <SkillProjects items={projects} color="green" />,
    <Stack techs={techs} />,
    <CallToAction id="contact" title={t("expertise.backend.ctaTitle")} text={t("expertise.backend.ctaText")} action={t("common.contactUs")} href={pathFor(routeIds.contact)} />,
    <OtherSkills mainSkill="back-end" />,
    <Projects />,
    <Drawer route={route} />
  ];
}

export default BackEnd;
